
import Editor from '@/components/editor/index.vue'
import CoverUpload from '@/components/cover_upload/index.vue'
import UploadImg from '@/common/class/UploadImg'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { CommonService } from '@/services'
import { ElForm } from 'element-ui/types/form'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { IMG_HOST } from '@/config/env'
import { parseTime } from '@/common/utils'

const validator = {
    required: true,
    message: '该项为必填项/必选项',
    trigger: 'blur'
}

@Component({
    name: 'institute-create',
    components: {
        Editor,
        CoverUpload,
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('formRef') private formEl!: ElForm
    @Ref('fileRef') private fileEl!: any
    @Ref('scrollRef') private scrollEl!: ScrollToType
    @Ref('editorRef') private editorEl!: any
    private typeList: any[] = []
    private detailId = 0
    private recommendTotal = 0
    private topTotal = 0
    private institute: any = {
        title: '',
        created_at: '',
        url: '',
        type: {
            id: -1,
            name: ''
        },
        abstract: '',
        content: '',
        organization: '',
        writer: '',
        cover_img: '',
        recommend: 0,
        top: 0,
        type_id: -1
    }
    private rules = {}
    private updateLoading = false
    private isLoading = false
    private isFixed = false

    created() {
        this.generateValidator()
    }
    async mounted() {
        this.detailId = +this.$route.params.id
        this.isLoading = true
        await Promise.all([this.fetchTypeData(), this.getDetail(), this.getArticles(true), this.getArticles()])
        this.isLoading = false
    }
    async fetchTypeData() {
        const result = await CommonService.getIArticleTypes({})
        if (result.status === 200) {
            this.typeList = result.data
        }
    }

    async getDetail() {
        const params = {
            id: this.detailId
        }
        const result = await CommonService.getIArticle(params)
        if (result.status === 200) {
            this.institute = result.data
            this.institute.type_id = result.data.type.id
        }
    }

    async getArticles(top = false) {
        const params = {
            type_id: this.institute.type.id
        }
        top && Object.assign(params, { top: 1 })
        !top && Object.assign(params, { recommend: 1 })
        const result = await CommonService.getIArticleList(params)
        if (result.status === 200) {
            if (top) {
                this.topTotal = result.data.page_total
            } else {
                this.recommendTotal = result.data.page_total
            }
        }
    }

    async deleteArticle() {
        const params = { id: this.detailId }
        const result = await CommonService.deleteIArticle(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    generateValidator() {
        const optionalFields = ['abstract', 'url', 'organization', 'writer']
        Reflect.ownKeys(this.institute).forEach(key => {
            if (key === 'cover_img') {
                Reflect.set(this.rules, key, [{ validator: this.imageValidator }])
            } else if (key === 'url') {
                Reflect.set(this.rules, key, [{ type: 'url', message: '请输入正确的链接', trigger: 'blur' }])
            } else if (optionalFields.includes(key as string)) {
                Reflect.set(this.rules, key, { ...validator, required: false })
            } else if (key === 'abstract') {
                Reflect.set(this.rules, key, { max: 300, message: '最多不能超过300子', trigger: 'blur' })
            } else {
                Reflect.set(this.rules, key, validator)
            }
        })
    }

    onUpdate() {
        this.formEl.validate(async (valid: boolean) => {
            if (!valid) return
            if (typeof this.institute.cover_img === 'object') {
                const result = await new UploadImg(this.institute.cover_img).upload()
                if (result.error) {
                    return this.$merror('发生错误, 图片上传失败, 请稍后再试')
                }
                this.institute.cover_img = IMG_HOST + result.key
            }
            this.onUpdateData()
        })
    }

    onDelete() {
        this.$confirm('正在进行删除操作，是否确认?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                await this.deleteArticle()
            })
            .catch(() => {})
    }

    imageValidator(rules: any, value: any, callback: Function) {
        if (!this.institute.cover_img) {
            callback(new Error('请输入/上传封面图'))
        }
        callback()
    }
    onCoverChange() {
        this.institute.cover_img = (this.$refs.coverUpload as any).getFile()
    }
    onRichTextChange(content: string) {
        this.institute.content = content
    }

    private async onUpdateData() {
        this.updateLoading = true

        this.institute.created_at = parseTime(this.institute.created_at)

        const params: any = {
            ...this.institute,
            id: this.detailId,
            type_id: this.institute.type_id
        }
        delete params.type
        const result = await CommonService.updateIArticle(params)
        this.updateLoading = false
        if (result.status === 200) {
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }

    async onRecommendChange() {
        if (this.institute.recommend) {
            if (this.recommendTotal >= 5) {
                this.$confirm('当前每个类型仅支持添加5篇推荐文章，请先移出', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const url = '/setting/institute/top/list'
                    window.open(url)
                })
                this.institute.recommend = 0
            } else {
                this.recommendTotal += 1
            }
        }
    }

    async onTopChange() {
        if (this.institute.top) {
            if (this.topTotal >= 6) {
                this.$confirm('当前仅支持添加6篇置顶文章，请先移出', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const url = '/setting/institute/top/list'
                    window.open(url)
                })
                this.institute.top = 0
            } else {
                this.topTotal += 1
            }
        }
    }

    onTypeChange(typeId: number) {
        this.institute = { ...this.institute, type_id: typeId }

    }

    onScroll() {
        const doc: HTMLElement = document.querySelector('.detail-page') as HTMLElement
        const targetEl: HTMLElement = document.querySelector('.editor-wrap') as HTMLElement
        const scrollTop = doc.scrollTop
        if (scrollTop - 50 > targetEl.offsetTop) {
            this.isFixed = true
        } else {
            this.isFixed = false
        }
    }
}
